/* Guided product template.
 *
 * Two modes, decided in Liquid and read here from `data-sp-guided`:
 *
 *   guided — two or more real decisions. The rail, the gate, Continue/Back.
 *   direct — one decision or none. Everything on one screen, Add to bag live
 *            from the start. A wizard around a single dropdown is theatre.
 *
 * Nothing is pre-selected. Shopify picks a first variant, but a pre-selection
 * is not the shopper agreeing to it — the first version showed a ticked size
 * while the status line read "choose a size", which is the contradiction that
 * made the page confusing.
 *
 * The cart POST is hand-rolled rather than handed to `theme.ProductForm`,
 * which this theme's other template uses. That class posts one variant; this
 * page can add the shoe and two care products together, and splitting that
 * into three requests would open the drawer three times. The event fired
 * afterwards is the one the theme's drawer listens for.
 */

(function () {
  "use strict";

  document.querySelectorAll(".sp").forEach(function (root) {
    if (root.dataset.spReady) return;
    root.dataset.spReady = "true";

    var guided = root.dataset.spGuided === "true";

    function parse(selector, fallback) {
      var node = root.querySelector(selector);
      if (!node) return fallback;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return fallback;
      }
    }

    var variants = parse("[data-sp-variants]", []);
    var copy = parse("[data-sp-copy]", {});

    var form = root.querySelector("#sp-form");
    var idField = root.querySelector("[data-sp-variant-id]");
    var panels = Array.prototype.slice.call(root.querySelectorAll("[data-sp-panel]"));
    var railItems = Array.prototype.slice.call(root.querySelectorAll("[data-sp-rail-item]"));
    var progress = root.querySelector("[data-sp-progress]");

    var hero = root.querySelector("[data-sp-hero]");
    var chosenEl = root.querySelector("[data-sp-chosen]");
    var priceEl = root.querySelector("[data-sp-total-price]");
    var compareEl = root.querySelector("[data-sp-compare]");
    var statusEl = root.querySelector("[data-sp-status]");
    var reviewEl = root.querySelector("[data-sp-review]");

    var backBtn = root.querySelector("[data-sp-back]");
    var nextBtn = root.querySelector("[data-sp-next]");
    var addBtn = root.querySelector("[data-sp-add]");
    var addLabel = root.querySelector("[data-sp-add-label]");

    var optionPanels = panels.filter(function (panel) {
      return panel.dataset.spOptionIndex !== undefined;
    });
    var total = panels.length;
    var step = 1;

    root.querySelectorAll("[data-sp-total]").forEach(function (node) {
      node.textContent = String(total);
    });

    /* What has been chosen, by option index.
     *
     * Every option rendered as a panel has more than one value, so none of
     * them starts answered. Options with a single value never become a panel
     * and are filled in at match time from the variant data.
     */
    var selection = [];
    var answered = [];

    optionPanels.forEach(function (panel) {
      var index = Number(panel.dataset.spOptionIndex);
      selection[index] = null;
      answered[index] = false;
    });

    // Single-value options: there is only one thing they can be, so take it
    // from the first variant and treat them as settled.
    if (variants.length) {
      var widths = (variants[0].options || []).length;
      for (var i = 0; i < widths; i += 1) {
        if (answered[i] !== undefined) continue;
        selection[i] = variants[0].options[i];
        answered[i] = true;
      }
    }

    function money(cents) {
      var value = (Number(cents) || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || "en", {
          style: "currency",
          currency:
            window.Shopify && window.Shopify.currency && window.Shopify.currency.active
              ? window.Shopify.currency.active
              : "USD",
        }).format(value);
      } catch (error) {
        return value.toFixed(2);
      }
    }

    function matchVariant() {
      for (var i = 0; i < variants.length; i += 1) {
        var options = variants[i].options || [];
        var same = true;
        for (var j = 0; j < selection.length; j += 1) {
          if (selection[j] != null && options[j] !== selection[j]) {
            same = false;
            break;
          }
        }
        if (same) return variants[i];
      }
      return null;
    }

    /* Could this value ever be bought, given what else is chosen?
     *
     * Checked against the other ANSWERED options only, so choosing a colour
     * greys the sizes that colour does not come in, rather than every size
     * that any other colour lacks. */
    function reachable(index, value) {
      for (var i = 0; i < variants.length; i += 1) {
        var options = variants[i].options || [];
        if (options[index] !== value) continue;
        if (!variants[i].available) continue;

        var ok = true;
        for (var j = 0; j < selection.length; j += 1) {
          if (j === index || !answered[j]) continue;
          if (selection[j] != null && options[j] !== selection[j]) {
            ok = false;
            break;
          }
        }
        if (ok) return true;
      }
      return false;
    }

    function addons() {
      return Array.prototype.slice.call(root.querySelectorAll("[data-sp-addon]:checked"));
    }

    function addonTotal() {
      return addons().reduce(function (sum, box) {
        return sum + (Number(box.dataset.spPrice) || 0);
      }, 0);
    }

    function complete() {
      return answered.every(Boolean);
    }

    function firstOpen() {
      for (var i = 0; i < optionPanels.length; i += 1) {
        if (!answered[Number(optionPanels[i].dataset.spOptionIndex)]) return i + 1;
      }
      return total;
    }

    function stepIsAnswered(which) {
      var panel = panels[which - 1];
      if (!panel || panel.dataset.spOptionIndex === undefined) return true;
      return answered[Number(panel.dataset.spOptionIndex)] === true;
    }

    /// The option's own name, for "Choose a size".
    function labelFor(which) {
      var panel = panels[which - 1];
      if (!panel || panel.dataset.spOptionIndex === undefined) return "";
      var group = panel.querySelector("[role=radiogroup]");
      return group ? group.getAttribute("aria-label") || "" : "";
    }

    /// The first option still unanswered — what direct mode asks for.
    function missingLabel() {
      for (var i = 0; i < optionPanels.length; i += 1) {
        if (!answered[Number(optionPanels[i].dataset.spOptionIndex)]) {
          return labelFor(i + 1);
        }
      }
      return "";
    }

    var makeBtn = root.querySelector("[data-sp-make]");
    var backInline = root.querySelector("[data-sp-back-inline]");
    var popping = false;

    // A small burst of colour from an element, to mark a step as done.
    // Skipped entirely under reduced motion.
    function burst(origin) {
      if (!origin || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      var rect = origin.getBoundingClientRect();
      var layer = document.createElement("div");
      layer.className = "sp-confetti";
      document.body.appendChild(layer);
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      var colours = ["#2f8a5b", "#f2c14e", "#d8553f", "#1f6fb2", "#ffffff"];
      for (var i = 0; i < 40; i += 1) {
        var piece = document.createElement("i");
        piece.style.left = cx + "px";
        piece.style.top = cy + "px";
        piece.style.background = colours[i % colours.length];
        layer.appendChild(piece);
        var dx = (Math.random() - 0.5) * 170;
        var dy = -(90 + Math.random() * 170);
        var spin = (Math.random() - 0.5) * 540;
        piece.animate(
          [
            { transform: "translate(0, 0) rotate(0deg)", opacity: 1 },
            { transform: "translate(" + dx + "px, " + (dy + 260) + "px) rotate(" + spin + "deg)", opacity: 0 },
          ],
          { duration: 1900 + Math.random() * 700, easing: "cubic-bezier(.2,.7,.3,1)", fill: "forwards" },
        );
      }
      window.setTimeout(function () {
        if (layer.parentNode) layer.parentNode.removeChild(layer);
      }, 2800);
    }

    // The picked colour's photograph moves to the front of the gallery and is
    // marked, so the page shows the choice as well as the summary image.
    function highlightGallery(variant) {
      var gallery = root.querySelector("[data-sp-gallery]");
      if (!gallery || !variant || !variant.mediaId) return;
      var figure = gallery.querySelector('[data-sp-media="' + variant.mediaId + '"]');
      if (!figure) return;
      if (gallery.firstElementChild !== figure) {
        gallery.insertBefore(figure, gallery.firstElementChild);
      }
      gallery.querySelectorAll(".sp-gallery__item").forEach(function (item) {
        item.classList.toggle("is-picked", item === figure);
      });
    }

    function render() {
      var variant = matchVariant();
      var done = complete();

      optionPanels.forEach(function (panel) {
        var index = Number(panel.dataset.spOptionIndex);
        panel.querySelectorAll("[data-sp-value]").forEach(function (button) {
          var value = button.dataset.spValue;
          var on = answered[index] && value === selection[index];
          button.classList.toggle("is-on", on);
          button.setAttribute("aria-checked", String(on));
          button.classList.toggle("is-gone", !reachable(index, value));
        });
      });

      if (guided) {
        railItems.forEach(function (item, i) {
          var which = i + 1;
          item.classList.toggle("is-on", which === step);
          item.classList.toggle("is-done", which < step && stepIsAnswered(which));
          if (which > firstOpen()) item.setAttribute("data-sp-locked", "");
          else item.removeAttribute("data-sp-locked");
        });

        if (progress) {
          progress.style.width = ((step - 1) / Math.max(1, total - 1)) * 100 + "%";
        }
      }

      if (variant && hero && variant.image) hero.src = variant.image;
      highlightGallery(variant);
      if (idField) idField.value = variant ? variant.id : "";

      var base = variant ? Number(variant.priceCents) || 0 : 0;
      if (priceEl) priceEl.textContent = money(base + addonTotal());
      updateOffer();

      if (compareEl) {
        var compare = variant ? Number(variant.compareCents) || 0 : 0;
        var show = compare > base;
        compareEl.hidden = !show;
        if (show) compareEl.textContent = money(compare + addonTotal());
      }

      if (chosenEl) {
        chosenEl.textContent = optionPanels
          .map(function (panel) {
            var index = Number(panel.dataset.spOptionIndex);
            if (!answered[index]) return null;
            var on = panel.querySelector("[data-sp-value].is-on");
            return on
              ? (on.querySelector(".sp-choice__label") || on).textContent.trim()
              : selection[index];
          })
          .filter(Boolean)
          .join(" · ");
      }

      var buyable = done && variant && variant.available;

      if (statusEl) {
        var missing = missingLabel();
        statusEl.disabled = !missing;
        statusEl.classList.toggle("is-action", Boolean(missing));
        if (done && !variant) {
          statusEl.textContent = copy.unavailable || "Not available";
          statusEl.classList.remove("is-ready");
        } else if (missing) {
          statusEl.textContent =
            (copy.choosePrefix || "Choose a") + " " + missing.toLowerCase();
          statusEl.classList.remove("is-ready");
        } else if (buyable) {
          statusEl.textContent = copy.ready || "";
          statusEl.classList.add("is-ready");
        } else {
          statusEl.textContent = "";
          statusEl.classList.remove("is-ready");
        }
      }

      if (guided) {
        var last = step === total;
        if (backBtn) backBtn.hidden = step === 1;
        if (backInline) backInline.hidden = step === 1;
        if (nextBtn) {
          nextBtn.hidden = last;
          nextBtn.disabled = !stepIsAnswered(step);
        }
        if (addBtn) {
          addBtn.hidden = !last;
          addBtn.disabled = !buyable;
        }
        if (makeBtn) makeBtn.disabled = !buyable;
        if (last) buildReview(variant);
      } else if (addBtn) {
        // Direct mode: one button, live as soon as the page can be bought.
        addBtn.disabled = !buyable;
      }

      if (addLabel) {
        addLabel.textContent =
          variant && !variant.available
            ? copy.soldOut || "Sold out"
            : copy.cta || "Add to bag";
      }
    }

    function row(parent, term, detail) {
      var div = document.createElement("div");
      var dt = document.createElement("dt");
      var dd = document.createElement("dd");
      dt.textContent = term;
      dd.textContent = detail;
      div.appendChild(dt);
      div.appendChild(dd);
      parent.appendChild(div);
    }

    function buildReview(variant) {
      if (!reviewEl) return;
      reviewEl.textContent = "";

      optionPanels.forEach(function (panel, i) {
        var on = panel.querySelector("[data-sp-value].is-on");
        row(
          reviewEl,
          labelFor(i + 1),
          on ? (on.querySelector(".sp-choice__label") || on).textContent.trim() : "—",
        );
      });

      if (root.querySelector("[data-sp-addon]")) {
        var picked = addons();
        row(
          reviewEl,
          copy.addonsTitle || "Extras",
          picked.length
            ? picked
                .map(function (box) {
                  return box.dataset.spTitle;
                })
                .join(", ")
            : copy.noneChosen || "Nothing added",
        );
      }

      row(
        reviewEl,
        "Total",
        money((variant ? Number(variant.priceCents) || 0 : 0) + addonTotal()),
      );
    }

    function show(which) {
      if (!guided) return;

      var target = Math.min(Math.max(1, which), total);
      // Never skip past something unanswered. The rail offers the jump; this
      // is what makes the offer honest.
      if (target > firstOpen()) target = firstOpen();

      var previous = step;
      step = target;
      if (!popping && target > previous && window.history && history.pushState) {
        history.pushState({ spStep: target }, "", window.location.href);
      }
      panels.forEach(function (panel, i) {
        var on = i + 1 === step;
        panel.hidden = !on;
        panel.classList.toggle("is-on", on);
      });

      render();

      if (guided && step === total && !popping && makeBtn) {
        window.setTimeout(function () {
          var reviewNumber = root.querySelector("[data-sp-rail-item]:last-child .sp-rail__n");
          burst(reviewNumber);
          burst(makeBtn);
        }, 180);
      }

      var stage = root.querySelector(".sp-stage");
      if (stage && window.scrollY > stage.offsetTop) {
        stage.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    // ── Wiring ──────────────────────────────────────────────────────────

    optionPanels.forEach(function (panel) {
      var index = Number(panel.dataset.spOptionIndex);

      panel.addEventListener("click", function (event) {
        var button = event.target.closest("[data-sp-value]");
        if (!button || !panel.contains(button)) return;
        selection[index] = button.dataset.spValue;
        answered[index] = true;
        var wasStep = step;
        render();
        if (guided && wasStep === Number(panel.dataset.spPanel) && wasStep < total) {
          window.setTimeout(function () {
            if (step === wasStep) show(wasStep + 1);
          }, 320);
        }
      });

      panel.addEventListener("keydown", function (event) {
        if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
        var buttons = Array.prototype.slice.call(panel.querySelectorAll("[data-sp-value]"));
        var at = buttons.indexOf(document.activeElement);
        if (at === -1) return;
        event.preventDefault();
        var move = event.key === "ArrowRight" ? 1 : -1;
        var next = buttons[(at + move + buttons.length) % buttons.length];
        next.focus();
        next.click();
      });
    });

    root.querySelectorAll("[data-sp-addon]").forEach(function (box) {
      box.addEventListener("change", render);
    });

    railItems.forEach(function (item, i) {
      var button = item.querySelector("[data-sp-goto]");
      if (button) {
        button.addEventListener("click", function () {
          show(i + 1);
        });
      }
    });

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        show(step + 1);
      });
    }
    if (backBtn) {
      backBtn.addEventListener("click", function () {
        show(step - 1);
      });
    }

    function cartRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    }

    if (form) {
      form.addEventListener("submit", function (event) {
        if (event.defaultPrevented) return;

        var variant = matchVariant();
        if (!variant || !complete()) {
          // Nothing to add yet. Say what is missing rather than posting a
          // variant the shopper never chose.
          event.preventDefault();
          render();
          return;
        }

        event.preventDefault();

        var items = [{ id: variant.id, quantity: 1 }];
        addons().forEach(function (box) {
          items.push({ id: Number(box.value), quantity: 1 });
        });

        var was = addLabel ? addLabel.textContent : "";
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = copy.adding || "Adding…";

        var restore = function () {
          if (addBtn) addBtn.disabled = false;
          if (addLabel) addLabel.textContent = was;
        };

        fetch(cartRoot() + "cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items }),
        })
          .then(function (response) {
            return response.json().then(function (body) {
              return { ok: response.ok, body: body };
            });
          })
          .then(function (result) {
            restore();

            if (!result.ok) {
              if (addLabel) {
                addLabel.textContent =
                  (result.body && (result.body.description || result.body.message)) ||
                  copy.unavailable ||
                  "Not available";
                window.setTimeout(function () {
                  addLabel.textContent = was;
                }, 3200);
              }
              return;
            }

            form.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: { product: result.body },
                bubbles: true,
              }),
            );

            if (!document.getElementById("CartDrawer")) {
              window.location.href = cartRoot() + "cart";
            }
          })
          .catch(function () {
            restore();
            form.submit();
          });
      });
    }

    // ── Footer clearance ────────────────────────────────────────────────
    // The summary is fixed to the bottom of the phone viewport, and the
    // footer sits after this section, so padding inside the section can
    // never clear it. The clearance belongs on <body>, and it has to be
    // measured rather than guessed: the bar's height changes with the
    // product name, the status line and the safe-area inset.
    var summary = root.querySelector(".sp-summary");
    if (summary) {
      var padded = false;

      var applyClearance = function () {
        var fixed = window.getComputedStyle(summary).position === "fixed";
        if (fixed) {
          document.body.style.paddingBottom = Math.ceil(summary.offsetHeight) + "px";
          padded = true;
        } else if (padded) {
          // Only clear what we set, so a theme's own bottom padding on a
          // wide screen survives.
          document.body.style.paddingBottom = "";
          padded = false;
        }
      };

      applyClearance();
      window.addEventListener("resize", applyClearance);
      window.addEventListener("orientationchange", applyClearance);

      if ("ResizeObserver" in window) {
        new ResizeObserver(applyClearance).observe(summary);
      }
    }

    // Back, one step: the browser's own history where it has the previous
    // step, otherwise a plain move.
    function goBack() {
      var prev = step - 1;
      if (prev < 1) return;
      if (window.history && history.state && history.state.spStep === prev) {
        history.back();
      } else {
        show(prev);
      }
    }

    if (backInline) backInline.addEventListener("click", goBack);

    if (statusEl) {
      statusEl.addEventListener("click", function () {
        var at = firstOpen();
        if (guided && at > 0) show(at);
      });
    }

    if (makeBtn && form) {
      makeBtn.addEventListener("click", function () {
        burst(makeBtn);
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
      });
    }

    if (guided) {
      window.addEventListener("popstate", function (event) {
        var target = event.state && event.state.spStep;
        if (!target) return;
        popping = true;
        show(target);
        popping = false;
      });
      if (window.history && history.replaceState) {
        history.replaceState(Object.assign({}, history.state, { spStep: 1 }), "", window.location.href);
      }
    }

    // On a phone the summary bar gets out of the way while the "Make it
    // yours" button is on screen, and returns once the shopper scrolls past it.
    var summaryBar = root.querySelector(".sp-summary");
    if (makeBtn && summaryBar && "IntersectionObserver" in window) {
      new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          summaryBar.classList.toggle("is-cta-visible", Boolean(entry && entry.isIntersecting));
        },
        { threshold: 0.4 },
      ).observe(makeBtn);
    }

    // Specifications open by default on a desktop; collapsed on a phone.
    if (window.matchMedia("(min-width: 861px)").matches) {
      var specsAcc = root.querySelector(".sp-specs-acc");
      if (specsAcc) specsAcc.open = true;
    }

    // ── Offer countdown ────────────────────────────────────────────────
    // Same logic as the immersive template. One deadline, kept in the
    // cp_offer_ends cookie and shared with that page: when it is missing,
    // expired or further away than one window, a fresh window starts. The
    // clock resets itself when it reaches zero, and reads red in the final
    // hour.
    var offers = Array.prototype.slice.call(root.querySelectorAll("[data-sp-offer]"));
    var OFFER_COOKIE = "cp_offer_ends";

    function readOfferCookie() {
      try {
        var hit = document.cookie.match("(?:^|; )" + OFFER_COOKIE + "=([^;]*)");
        return hit ? Number(decodeURIComponent(hit[1])) : NaN;
      } catch (error) {
        return NaN;
      }
    }

    function writeOfferCookie(expiresAt) {
      try {
        document.cookie =
          OFFER_COOKIE + "=" + encodeURIComponent(String(expiresAt)) +
          "; path=/; max-age=" + Math.ceil((expiresAt - Date.now()) / 1000) + "; SameSite=Lax";
      } catch (error) {
        // Storage blocked: the clock still runs, it just restarts on reload.
      }
    }

    function pad(value) {
      return value < 10 ? "0" + value : String(value);
    }

    var clocks = offers
      .map(function (node) {
        var clock = node.querySelector("[data-sp-clock]");
        if (!clock) return null;
        var windowMs = (Number(node.dataset.spHours) || 88) * 36e5;
        var stored = readOfferCookie();
        var target = stored && stored > Date.now() && stored <= Date.now() + windowMs
          ? stored
          : Date.now() + windowMs;
        writeOfferCookie(target);
        return {
          node: node,
          clock: clock,
          windowMs: windowMs,
          target: target,
          d: clock.querySelector("[data-d]"),
          h: clock.querySelector("[data-h]"),
          m: clock.querySelector("[data-m]"),
          s: clock.querySelector("[data-s]"),
        };
      })
      .filter(Boolean);

    function tickOffers() {
      clocks.forEach(function (c) {
        // Follow the shared cookie, so every copy on the page resets together.
        var stored = readOfferCookie();
        if (stored && stored > Date.now() && stored <= Date.now() + c.windowMs) {
          c.target = stored;
        }
        var left = c.target - Date.now();
        if (left <= 0) {
          c.target = Date.now() + c.windowMs;
          writeOfferCookie(c.target);
          left = c.windowMs;
        }
        var total = Math.floor(left / 1000);
        if (c.d) c.d.textContent = pad(Math.floor(total / 86400));
        if (c.h) c.h.textContent = pad(Math.floor((total % 86400) / 3600));
        if (c.m) c.m.textContent = pad(Math.floor((total % 3600) / 60));
        if (c.s) c.s.textContent = pad(total % 60);
        c.clock.classList.toggle("is-final", left < 36e5);
      });
    }

    if (clocks.length) {
      offers.forEach(function (node) {
        node.classList.add("is-live");
      });
      tickOffers();
      var offerTicker = window.setInterval(tickOffers, 1000);
      document.addEventListener("visibilitychange", function () {
        if (!document.hidden) tickOffers();
      });
      window.addEventListener("pagehide", function () {
        window.clearInterval(offerTicker);
      });
    }

    // "You could be paying X more after" — the gap between the compare-at
    // price and the price in hand, for the variant currently chosen. Shown
    // only when there is a real gap; otherwise the plain label stands.
    function updateOffer() {
      if (!offers || !offers.length) return;
      var variant = matchVariant();
      var base = variant ? Number(variant.priceCents) || 0 : 0;
      var compare = variant ? Number(variant.compareCents) || 0 : 0;
      var saving = compare > base ? money(compare - base) : "";
      root.querySelectorAll("[data-sp-after]").forEach(function (el) {
        el.textContent = compare > base ? money(compare) : "";
      });
      offers.forEach(function (node) {
        node.classList.toggle("has-saving", Boolean(saving));
        node.querySelectorAll("[data-sp-saving]").forEach(function (el) {
          el.textContent = saving;
        });
      });
    }

    updateOffer();

    if (guided) show(1);
    else render();
  });
})();
